import { Action } from '../../actions';
import { CHANGE_IMPORT_MODE } from '../../actions/importWizard/changeImportMode';
import { RESET_IMPORT_WIZARD } from '../../actions/importWizard/resetImportWizard';
import { SAVE_IMPORT_WIZARD_FILE } from '../../actions/importWizard/saveImportWizardFile';
import { SHOW_UPLOAD_FILE_IMPORT_WIZARD_REQUEST_ERROR } from '../../actions/importWizard/showUploadFileImportWizardRequestError';
import { UPDATE_IMPORT_WIZARD_DATA } from '../../actions/importWizard/updateImportWizardData';
import { UPDATE_IMPORT_WIZARD_STEP } from '../../actions/importWizard/updateImportWizardStep';
import { ImportWizardPhase, ImportWizardState, ImportWizardUploadMode } from '../../typings/importWizard';

import { changeImportMode } from './changeImportMode';
import { resetImportWizard } from './resetImportWizard';
import { saveImportWizardFile } from './saveImportWizardFile';
import { showUploadFileImportWizardRequestError } from './showUploadFileImportWizardRequestError';
import { updateImportWizardData } from './updateImportWizardData';
import { updateImportWizardStep } from './updateImportWizardStep';

export const getImportWizardInitialState = (): ImportWizardState => ({
    phase: ImportWizardPhase.FILE_UPLOAD,
    importMode: ImportWizardUploadMode.ONLY_AD_GROUPS
});

export function importWizard(
    state: ImportWizardState = getImportWizardInitialState(),
    action: Action
): ImportWizardState {
    switch (action.type) {
        case SAVE_IMPORT_WIZARD_FILE:
            return saveImportWizardFile(state, action);

        case UPDATE_IMPORT_WIZARD_DATA:
            return updateImportWizardData(state, action);

        case SHOW_UPLOAD_FILE_IMPORT_WIZARD_REQUEST_ERROR:
            return showUploadFileImportWizardRequestError(state, action);

        case CHANGE_IMPORT_MODE:
            return changeImportMode(state, action);

        case UPDATE_IMPORT_WIZARD_STEP:
            return updateImportWizardStep(state, action);

        case RESET_IMPORT_WIZARD:
            return resetImportWizard(state, action);

        default:
            return state;
    }
}
